import React from "react";
import useHover from "../hooks/useHover";

const FireCounter = ({
  image,
  backgroundColor,
  counter,
  sizePercentage,
  resizingBoxes,
  hoverDescription,
}) => {
  const hover = useHover(hoverDescription);
  return (
    <div
      {...hover.divProps}
      className="divRow"
      style={{
        backgroundColor: backgroundColor,
        borderRadius: "1rem/1rem",
        paddingRight: resizingBoxes
          ? `${(8 / 100) * sizePercentage.total}px`
          : "8px",
        paddingLeft: resizingBoxes
          ? `${(8 / 100) * sizePercentage.total}px`
          : "8px",
        paddingTop: "1px",
      }}
    >
      <img
        src={image}
        style={{
          objectFit: "contain",
          height: resizingBoxes
            ? `${(25 / 100) * sizePercentage.total}px`
            : "25px",
        }}
      />
      <div
        className="textWhite"
        style={{
          marginLeft: "1px",
          borderRadius: "1rem/1rem",
        }}
      >
        {counter}
      </div>
      {hover.hoverDescription}
    </div>
  );
};

export default FireCounter;
